import { ColumnActionsMode } from '@fluentui/react';
import { ColumnData } from 'common/components/SearchBar';
import useGetScreenWidth from 'common/hooks/useGetScreenWidth';
import {
  colHeaderLeftAlignStyle,
  commonColumnProps,
  rightAlignHeaderStyle,
} from 'common/utils/columnUtilities';
import { useCommonStyles } from 'common/styles';

const useColumns = () => {
  const { isSm, isLg } = useGetScreenWidth();
  const styles = useCommonStyles();
  const columns: ColumnData[] = [
    {
      key: '_urgencyLevel',
      name: '',
      showColumnTitle: 'Urgent',
      fieldName: '_urgencyLevel',
      minWidth: 5,
      maxWidth: 5,
      styles: colHeaderLeftAlignStyle,
      columnActionsMode: ColumnActionsMode.disabled,
      className: styles.urgencyColumn,
      ...commonColumnProps,
    },
    {
      key: 'description',
      name: 'Cycle',
      fieldName: 'description',
      minWidth: 270,
      ...commonColumnProps,
    },
    {
      key: '_paymentType',
      name: 'Type',
      fieldName: '_paymentType',
      minWidth: 150,
      ...commonColumnProps,
      isVisible: !isSm,
    },
    {
      key: '_paymentAccount',
      name: 'Bank account',
      fieldName: '_paymentAccount',
      minWidth: 200,
      ...commonColumnProps,
      isVisible: isLg,
    },
    {
      key: 'defaultPaymentDate',
      name: 'Payment Date',
      fieldName: 'defaultPaymentDate',
      minWidth: 120,
      styles: rightAlignHeaderStyle,
      ...commonColumnProps,
    },
    {
      key: 'currencyIsoCode',
      name: 'Currency',
      fieldName: 'currencyIsoCode',
      minWidth: 80,
      ...commonColumnProps,
      isVisible: isLg,
    },
    {
      key: 'controlTotalAmount',
      name: 'Cycle Total',
      fieldName: 'controlTotalAmount',
      minWidth: 120,
      styles: rightAlignHeaderStyle,
      ...commonColumnProps,
    },
    {
      key: '_totalPayments',
      name: 'Total Payments',
      fieldName: '_totalPayments',
      minWidth: 120,
      styles: rightAlignHeaderStyle,
      ...commonColumnProps,
      isVisible: isLg,
    },
    {
      key: '_paymentCount',
      name: 'Payments',
      fieldName: '_paymentCount',
      minWidth: 70,
      styles: rightAlignHeaderStyle,
      ...commonColumnProps,
      isVisible: isLg,
    },
    {
      key: 'status',
      name: 'Status',
      fieldName: 'status',
      minWidth: 150,
      ...commonColumnProps,
    },
  ];
  return { columns };
};
export { useColumns };
